import { Action } from '@ngrx/store';
import { CreateUserAccountPacket } from '../../model/form-data';
export interface GenericActionPayload {
    data: string;
}

export enum CreateProfileUIActions {
    CreateUserAccountBtnClicked = '[UI] Create User Account Btn Clicked',
    ResetCreateProfileState = '[UI] Reset Create Profile State',
}

export class CreateUserAccountBtnClicked implements Action {
    readonly type: CreateProfileUIActions =
        CreateProfileUIActions.CreateUserAccountBtnClicked;
    readonly payload: CreateUserAccountPacket;

    constructor(formData: CreateUserAccountPacket) {
        this.payload = formData;
    }
}

export class ResetCreateProfileState implements Action {
    readonly type: CreateProfileUIActions =
        CreateProfileUIActions.ResetCreateProfileState;
}
